export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7384_93082)">
                <path
                    d="M18 25.5C18 25.8955 17.8827 26.2823 17.6629 26.6111C17.4431 26.94 17.1308 27.1963 16.7654 27.3477C16.3999 27.4991 15.9978 27.5388 15.6098 27.4616C15.2218 27.3844 14.8655 27.1939 14.5857 26.9142C14.306 26.6345 14.1156 26.2782 14.0384 25.8902C13.9613 25.5023 14.0008 25.1 14.1522 24.7346C14.3036 24.3691 14.5599 24.0569 14.8888 23.8372C15.2177 23.6174 15.6044 23.5 16 23.5C16.5304 23.5 17.0391 23.7107 17.4142 24.0858C17.7893 24.4609 18 24.9695 18 25.5Z"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinejoin="round"
                />
                <path d="M17 26.5L15 24.5" stroke="black" strokeWidth="0.96" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M21.6702 22.132C20.0207 19.4646 20.602 18.5 20.602 18.5H11.4144C11.4144 18.5 11.9957 19.4646 10.3424 22.132C8.68909 24.7995 9.02882 27.133 9.02882 27.133V28.0976C9.02882 28.4696 9.17914 28.8263 9.44672 29.0892C9.7143 29.3522 10.0772 29.5 10.4556 29.5H21.5608C21.9362 29.4961 22.2948 29.3465 22.5586 29.0838C22.8223 28.8211 22.9697 28.4667 22.9687 28.0976V27.1442C22.9687 27.1442 23.3198 24.8032 21.6702 22.132Z"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M12 20.5H20" stroke="black" strokeWidth="0.96" strokeLinecap="square" strokeLinejoin="round" />
                <path
                    d="M22.181 5.37143L9.82812 5.30371L10.8976 6.33405C10.8976 6.33405 10.9796 17.6672 12.6017 18.4337"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.6831 5.36816C21.6831 5.36816 21.3266 17.6675 19.7188 18.434"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.2344 4.79288C12.3856 4.60534 12.5906 4.5 12.8045 4.5H19.192C19.4058 4.5 19.6109 4.60534 19.7621 4.79288"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.6591 4.04868C16.665 3.97887 16.6563 3.9086 16.6336 3.84231C16.6109 3.77603 16.5748 3.7152 16.5273 3.66363C16.4799 3.61206 16.4223 3.5709 16.3581 3.54273C16.294 3.51457 16.2247 3.5 16.1546 3.5C16.0846 3.5 16.0153 3.51457 15.9512 3.54273C15.887 3.5709 15.8294 3.61206 15.782 3.66363C15.7346 3.7152 15.6984 3.77603 15.6757 3.84231C15.653 3.9086 15.6443 3.97887 15.6502 4.04868"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.2812 7.49414C13.2812 7.49414 13.532 14.4618 14.2652 16.2741"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.5543 7.49414C19.5543 7.49414 19.3036 14.4618 18.5703 16.2741"
                    stroke="black"
                    strokeWidth="0.96"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.4297 7.48242V16.2737" stroke="black" strokeWidth="0.96" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7384_93082">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
